import { useContext, useEffect, useState } from "react";
import { ClientConfigurationContext } from "../../context/ClientConfigurationContextProvider";
import { UserContext } from "../../context/UserContextProvider";
import { AgentAccessContext } from "../../context/AgentAccessContextProvider";
import { getAgencyProfileForSweeps } from "../../api/agency-profile";

const NavMenuList = () => {
    const user = useContext(UserContext);
    const clientConfiguration = useContext(ClientConfigurationContext);
    const agentAccess = useContext(AgentAccessContext);
    const [agencyProfile, setAgencyProfile] = useState({});

    useEffect(() => {
        if (user && !clientConfiguration.enableReportsSalesLeader) {
            if (clientConfiguration.iaSweepsSwitch) {
                getAgencyProfileForSweeps(user.agencyId, response => {
                    setAgencyProfile(response)
                });
            } else {
                setAgencyProfile([]);
            }
        }

    }, [user]);

    let itemsList = [];

    if (clientConfiguration.enableProfileManagement && user.authorizations?.canManageProfileManagement) {
        itemsList.push({
            path: "",
            title: "Profile Management",
            trackingId: "ProfileManagement",
            children: [
                ...(clientConfiguration.enableAgencyProfileTab ? [{
                    path: "/profiles",
                    title: "My Profile",
                    trackingId: "MyProfile",
                    state: { myProfile: true },
                    children: []
                }] : []),
                ...(clientConfiguration.enableMyAgentsTab ? [{
                    path: "/profiles",
                    title: "My Agents",
                    trackingId: "MyAgents",
                    state: { agentId: user.agentId },
                    children: []
                }] : []),
                ...(clientConfiguration.enableAgencyProfileTab ? [{
                    path: "/profiles",
                    title: "Agency Profile",
                    trackingId: "AgencyProfile",
                    state: { agencyId: user.agencyId },
                    children: []
                }] : []),
                ...(clientConfiguration.enableAgencyBranchesTab ? [{
                    path: "/profiles",
                    title: "Agency Branches",
                    trackingId: "AgencyBranches",
                    state: { agencyBranches: true },
                    children: []
                }] : []),
                ...(clientConfiguration.enableAgencyGroupTab ? [{
                    path: "/profiles",
                    title: "Agency Group",
                    trackingId: "AgencyGroup",
                    state: { agencyGroup: true },
                    children: []
                }] : []),
                ...(clientConfiguration.enableErrorsAndOmissionsTab ? [{
                    path: "/profiles",
                    title: "Errors & Omissions (E&O)",
                    trackingId: "ErrorsAndOmissions",
                    state: { errorsAndOmissions: true },
                    children: []
                }] : []),
                ...(agencyProfile?.sweepDetails?.IsSweepsEligible && !agencyProfile?.isBranch ? [{
                    path: "/profiles",
                    title: "Sweeps Account Management",
                    trackingId: "SweepsAccountManagement",
                    state: { agencyProfile: agencyProfile },
                    children: []
                }] : []),
            ]
        })
    }
    if (clientConfiguration.enableAgencyDefaults && user.authorizations?.canSetAgencyDefaults) {
        itemsList.push({
            path: "agency-defaults-management",
            title: "Agency Defaults Management",
            trackingId: "AgencyDefaultsManagement",
            children: [
                {
                    path: "/defaults",
                    title: "Agency Defaults",
                    trackingId: "AgencyDefaults",
                    children: []
                }
            ]
        })
    }
    if (clientConfiguration.enableReports && user.authorizations?.canAccessReports && agentAccess?.externalReportsEnabled) {
        itemsList.push({
            path: "reports",
            title: "Reports",
            trackingId: "Reports",
            children: []
        })
    }
    if (clientConfiguration.enableIvansRequest && user.authorizations?.canManageIvansRequests) {
        itemsList.push({
            path: "ivans-request",
            title: "IVANS Request",
            trackingId: "IvansRequest",
            children: [
                {
                    path: "/policy-sync",
                    title: "Policy Sync",
                    trackingId: "PolicySync",
                    children: []
                },
                {
                    path: "/initial-load",
                    title: "Initial Load",
                    trackingId: "InitialLoad",
                    children: []
                }
            ]
        })
    }
    if (clientConfiguration.enableBankTab && user.authorizations?.canManageBanking) {
        itemsList.push({
            path: "bank-info",
            title: "Bank and W-9 Info",
            trackingId: "BankAndW9Info",
            children: [
                {
                    path: "/onboarding-commission-tax-form",
                    title: "Submit W-9",
                    trackingId: "SubmitW9",
                    children: []
                },
                {
                    path: "/commission-banking-details",
                    title: "Submit Bank Info",
                    trackingId: "SubmitBankInfo",
                    children: []
                },
            ]
        })
    }
    itemsList.push(...getAdminTabMenu(clientConfiguration, user));
    return itemsList
}

function getAdminTabMenu(clientConfiguration, user) {
    if (!clientConfiguration.enableAdminTab || !user.authorizations?.canManageAdmin) {
        return [];
    }

    return [{
        path: "admin",
        title: "Admin",
        trackingId: "Admin",
        children: [
            ...(clientConfiguration.displayAgentTerminationRequest && user.authorizations?.canTerminateAgent ? [{
                path: "/agent-termination",
                title: "Terminate an Agent",
                trackingId: "TerminateAgent",
                children: []
            }] : []),
            ...(clientConfiguration.displayAssignCompensationDelegate ? [{
                path: "/#",
                title: "Assign Delegate for Compensation Management",
                trackingId: "AssignCompensationDelegate",
                children: []
            }] : []),
            ...(clientConfiguration.displayAssignDelegateForOnboardingAgents ? [{
                path: "/#",
                title: "Assign Delegate for Onboarding Agents",
                trackingId: "AssignOnboardingDelegate",
                children: []
            }] : []),
            ...(clientConfiguration.displayResendOnboardingInvites ? [{
                path: "/#",
                title: "Resend Onboarding Invite To Agents",
                trackingId: "ResendOnboardingInvite",
                children: []
            }] : []),
            ...(clientConfiguration.displayClientAlertEmailPreferences && user.authorizations?.canManageClientPreferences ? [{
                path: "/client-alert-email-preferences",
                title: "Client Alert Email Preferences",
                trackingId: "ClientAlertEmailPreferences",
                children: []
            }] : []),
            ...(clientConfiguration.displayManageBindingAuthority && user.authorizations?.canSetBindingAuthority ? [{
                path: "/manage-binding-authority",
                title: "Manage Employee Binding Authority",
                trackingId: "ManageBindingAuthority",
                children: []
            }] : [])
        ]
    }];

}

export { getAdminTabMenu };
export default NavMenuList